import type { MessageValue } from 'contexts/intl/intlContext';
import type { IntlKey } from 'locales';
import { connect } from 'react-redux';
import { getTechnicalError } from 'state/selectors';
import { getTradeInfosByWorkspaceTab } from 'state/selectors/common/temp';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

const defaultTechnicalErrorKey: IntlKey = 'quote.errorMessages.TechnicalError';

export interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
  isForBooking?: boolean;
}

export interface StateProps {
  message: string;
  values?: Record<string, MessageValue>;
}

export type ErrorState = StateProps & OwnProps;

const mapStateToProps = (state: AppState, { tabId, workspaceType, isForBooking }: OwnProps): StateProps => {
  const tradeInfos = getTradeInfosByWorkspaceTab(state, workspaceType, tabId);
  const technicalError = getTechnicalError(state, workspaceType, tabId, isForBooking);

  if (!technicalError) {
    return {
      message: defaultTechnicalErrorKey,
    };
  }
  if (tradeInfos.tradeAuthStatus === 'Timeout') {
    return {
      message: 'quote.errorMessages.tradeAuthorizationTimeout',
    };
  }

  return {
    message: technicalError.message,
    values: technicalError.values,
  };
};

export const connectError = connect(mapStateToProps);
